import { render } from "./ExcelReferences.vue?vue&type=template&id=6010823a"
import script from "./ExcelReferences.vue?vue&type=script&lang=js"
export * from "./ExcelReferences.vue?vue&type=script&lang=js"

import "./ExcelReferences.vue?vue&type=style&index=0&id=6010823a&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__